import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function HeartyLentilStew() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Hearty Lentil Stew</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        40g dried porcini mushrooms, roughly chopped<br></br>
        200g dried brown lentils<br></br>1 ½ tbsp chopped rosemary<br></br>3
        tbsp rapeseed oil<br></br>2 large onions, roughly chopped<br></br>
        150g chestnut baby button mushrooms<br></br>4 garlic cloves, finely
        grated<br></br>2 tbsp vegetable bouillon powder<br></br>2 large carrots
        (350g), cut into chunks<br></br>3 celery sticks (165g), chopped<br></br>
        500g potatoes, cut into chunks<br></br>
        200g cavolo nero, shredded<br></br>
      </Typography>

      <Typography>
        Cover the mushrooms in boiling water and leave to soak for 10 mins. Boil
        the lentils in a pan with plenty of water for 10 mins. Drain and rinse,
        then tip into a pan with the dried mushrooms and soaking water (don’t
        add the last bit of the liquid as it can contain some grit), rosemary
        and 2 litres water. Season, cover and simmer for 20 mins.<br></br>
        Meanwhile, heat the oil in a large pan and fry the onions for 5 mins.
        Stir in the fresh mushrooms and garlic and fry for 5 mins more. Stir in
        the lentil mixture and bouillon powder, then add the carrots, celery and
        potatoes. Cover and cook for 20 mins, stirring often, until the veg and
        lentils are tender, topping up the water level if needed.<br></br>
        Remove any tough stalks from the cavolo nero, then add to the pan and
        cover and cook for 5 mins more. If you're following our Healthy Diet
        Plan, serve half in bowls, then chill the rest to eat another day. Will
        keep in the fridge for two to three days. Reheat in a pan until hot.
        <br></br>
      </Typography>
    </Card>
  );
}
